import * as Sentry from '@sentry/react';
import config from './config';

export const getReduxMiddleware = () => Sentry.createReduxEnhancer({});

/**
 * Log an error
 * @param {Error} error
 */
export const error = error => {
    if(config.environment === 'dev') return console.error(error);
    if(typeof error === 'string') return Sentry.captureMessage(error);
    const errorObj = Object.keys(error).reduce((errorObj, key) => {
        errorObj[key] = error[key];
        return errorObj;
    }, {})
    errorObj.stringStack = error.stack;
    Sentry.setContext('error', errorObj)
    Sentry.captureException(error);
}

/**
 *
 * @param {string} key
 * @param {Object} context
 */
export const setContext = (key, context) => Sentry.setContext(key, context)